import React, { useState } from 'react';
import { changePassword } from '../api/api';
import { uiToastSuccess, uiToastError } from '../components/Toast';

const PASSWORD_RE = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^\w\s]).{10,}$/;
const PASSWORD_HINT = 'Mínimo 10 caracteres, con mayúscula, minúscula, número y símbolo.';

// Pantalla obligatoria cuando administración le asignó una contraseña temporal al miembro
// (must_change_password = true en el perfil, ver App.js). No tiene forma de saltarla ni de
// navegar a otra parte del sitio hasta que la cambie — a propósito, para que nadie se quede
// usando la temporal que le dieron en la junta.
function CambiarPassword({ onChanged }) {
  const [currentPassword, setCurrentPassword] = useState('');
  const [password, setPassword] = useState('');
  const [password2, setPassword2] = useState('');
  const [error, setError] = useState(null);
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    if (!currentPassword) return setError('Ingresa la contraseña temporal que te dieron.');
    if (!PASSWORD_RE.test(password)) return setError(PASSWORD_HINT);
    if (password !== password2) return setError('Las contraseñas no coinciden.');

    setSubmitting(true);
    try {
      await changePassword(currentPassword, password);
      uiToastSuccess('Contraseña actualizada.');
      onChanged();
    } catch (err) {
      setError(err.response?.data?.error || 'No se pudo actualizar la contraseña');
      uiToastError('No se pudo actualizar la contraseña');
    }
    setSubmitting(false);
  };

  return (
    <div className="page-narrow">
      <h1 className="page-title">Crea tu contraseña</h1>
      <p className="page-subtitle">
        Administración te dio una contraseña temporal para entrar por primera vez. Antes de seguir, crea una contraseña propia que solo tú conozcas.
      </p>

      <div className="card">
        <form onSubmit={handleSubmit}>
          {error && <div className="msg-banner error">{error}</div>}
          <div className="form-group">
            <label className="form-label">Contraseña temporal (la que te dieron)</label>
            <input
              type="password"
              className="form-input"
              value={currentPassword}
              onChange={(e) => setCurrentPassword(e.target.value)}
              required
              autoFocus
            />
          </div>
          <div className="form-group">
            <label className="form-label">Tu nueva contraseña</label>
            <input
              type="password"
              className="form-input"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              minLength={10}
            />
            <span className="form-hint">{PASSWORD_HINT}</span>
          </div>
          <div className="form-group">
            <label className="form-label">Confirmar nueva contraseña</label>
            <input
              type="password"
              className="form-input"
              value={password2}
              onChange={(e) => setPassword2(e.target.value)}
              required
              minLength={10}
            />
          </div>
          <button type="submit" disabled={submitting} className="btn btn-primary btn-block">
            {submitting ? 'Guardando...' : 'Guardar y entrar'}
          </button>
        </form>
      </div>
    </div>
  );
}

export default CambiarPassword;
